import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '~/node_modules/@web/shared-digital-library/icons/svg-originals/video-icon-play.svg';
import { mapMutations } from 'vuex';

const SquareImage = () => import(
/* webpackChunkName: "square-image" */
'~/components/atoms/Product/SquareImage.vue');

const ThumbnailListArrowButton = () => import(
/* webpackChunkName: "thumbnail-list" */
'~/components/molecules/Product/ThumbnailListArrowButton.vue');

export default {
  name: 'ThumbnailList',
  components: {
    SquareImage,
    ThumbnailListArrowButton
  },
  props: {
    medias: {
      type: Array,
      required: true
    },
    index: {
      type: Number,
      default: 0
    },
    isSlider: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentIndex: this.index
    };
  },

  computed: {
    maxIndex() {
      return this.medias.length - 1;
    }

  },
  watch: {
    index(newValue) {
      if (newValue !== this.currentIndex) {
        this.currentIndex = newValue;
        this.scroll();
      }
    },

    images() {
      this.updateIndex(0);
    }

  },

  mounted() {
    if (this.index > 0) {
      this.scroll(false);
    }
  },

  methods: _objectSpread({}, mapMutations({
    setCurrentImage: 'product/SET_CURRENT_IMAGE',
    resetCurrentImage: 'product/RESET_CURRENT_IMAGE'
  }), {
    isVideo(media) {
      return media.type;
    },

    updateIndex(index) {
      if (this.currentIndex !== index) {
        this.currentIndex = index;
        this.$emit('update:index', this.currentIndex);
      }
    },

    selectIndexAndScroll(index) {
      this.updateIndex(index);
      this.scroll();
    },

    incrementIndex() {
      if (this.currentIndex + 1 < this.medias.length) {
        this.currentIndex = this.currentIndex + 1;
        this.$emit('update:index', this.currentIndex);
        this.scroll();
      }
    },

    decrementIndex() {
      if (this.currentIndex - 1 >= 0) {
        this.currentIndex = this.currentIndex - 1;
        this.$emit('update:index', this.currentIndex);
        this.scroll();
      }
    },

    scroll() {
      let smooth = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      const scrollSize = this.$refs.thumbnail[0].offsetHeight * this.currentIndex;
      this.$refs.slider.scrollTo({
        top: scrollSize,
        behavior: smooth ? 'smooth' : 'auto'
      });
      this.$refs.wrapper.scrollTo({
        top: scrollSize,
        behavior: smooth ? 'smooth' : 'auto'
      });
    }

  })
};